<div class="container max-w-7xl mx-auto px-4 mb-10 lg:mb-20">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ">
    @for (item of items; track $index) {
    <div class="col">
      <div class="card rounded-3xl border-gray-200 border-2 p-4 text-center glass-effect">
        <h2 class="text-2xl lg:text-4xl flex justify-center items-center gap-1 my-3 font-bold">
          <span class="text-primary-500 text-4xl">+</span>
          <span>{{ item.title }}</span>
        </h2>
        <p class="text-xl leading-tight">{{ item.body }}</p>
      </div>
    </div>
    }
  </div>
</div>